import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-100 border-t border-background-300/30">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          <div className="lg:w-1/3">
            <Link to="/" className="inline-block mb-4">
              <span className="text-2xl md:text-3xl font-heading font-bold text-foreground-50">
                <span className="text-primary-500">51</span>爆料网
              </span>
            </Link>
            <p className="text-foreground-500 text-sm leading-relaxed max-w-sm">
              51爆料网每日爆料黑料吃瓜，提供51今日大瓜及每日大赛往期内容。独家八卦、往期精华免费回顾，吃瓜不停，立即查看。
            </p>
            <div className="flex items-center gap-3 mt-5">
              {[
                { icon: 'ri-weibo-line', label: '微博', href: '#' },
                { icon: 'ri-wechat-line', label: '微信', href: '#' },
                { icon: 'ri-music-line', label: '抖音', href: '#' },
                { icon: 'ri-bilibili-line', label: 'B站', href: '#' },
              ].map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  className="w-9 h-9 rounded-full border border-foreground-700/30 flex items-center justify-center text-foreground-500 hover:text-primary-400 hover:border-primary-500/50 transition-all duration-200"
                  aria-label={social.label}
                  rel="nofollow"
                >
                  <i className={`${social.icon} text-sm`} />
                </a>
              ))}
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-8 lg:gap-16 flex-1">
            <div>
              <h4 className="text-foreground-300 font-heading font-semibold text-xs uppercase tracking-wider mb-4">热门分类</h4>
              <ul className="flex flex-col gap-2.5">
                {[
                  { label: '明星黑料', path: '/category/mingxing-heidong' },
                  { label: '综艺吃瓜', path: '/category/zongyi-chigua' },
                  { label: '影视揭秘', path: '/category/yingshi-jiemi' },
                  { label: '每日大赛', path: '/category/meiri-dasai' },
                  { label: '互联网瓜', path: '/category/hulianwang-gua' },
                ].map((item) => (
                  <li key={item.path}>
                    <Link to={item.path} className="text-foreground-500 text-sm hover:text-primary-400 transition-colors">
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-foreground-300 font-heading font-semibold text-xs uppercase tracking-wider mb-4">关于我们</h4>
              <ul className="flex flex-col gap-2.5">
                {[
                  { label: '品牌介绍', path: '/about' },
                  { label: '联系我们', path: '/about#contact' },
                  { label: '投稿爆料', path: '/about#submit' },
                  { label: '隐私政策', path: '/about#privacy' },
                ].map((item) => (
                  <li key={item.path}>
                    <Link to={item.path} className="text-foreground-500 text-sm hover:text-primary-400 transition-colors">
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-foreground-300 font-heading font-semibold text-xs uppercase tracking-wider mb-4">联系方式</h4>
              <address className="not-italic">
                <div className="flex flex-col gap-2.5">
                  <div className="flex items-center gap-2 text-foreground-500 text-sm">
                    <i className="ri-mail-line text-foreground-600" />
                    <span>hello@921xwm.cn</span>
                  </div>
                  <div className="flex items-center gap-2 text-foreground-500 text-sm">
                    <i className="ri-map-pin-line text-foreground-600" />
                    <span>中国 · 北京</span>
                  </div>
                  <div className="flex items-center gap-2 text-foreground-500 text-sm">
                    <i className="ri-phone-line text-foreground-600" />
                    <span>400-888-5151</span>
                  </div>
                </div>
              </address>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background-300/30">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-foreground-600 text-xs">
            &copy; {currentYear} 51爆料网. All rights reserved.
          </p>
          <div className="flex items-center gap-5">
            <Link to="/about#privacy" className="text-foreground-600 text-xs hover:text-foreground-400 transition-colors">
              隐私政策
            </Link>
            <Link to="/about#terms" className="text-foreground-600 text-xs hover:text-foreground-400 transition-colors">
              服务条款
            </Link>
            <Link to="/about" className="text-foreground-600 text-xs hover:text-foreground-400 transition-colors">
              关于我们
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}